// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"_103u1NpbKCwx","imageWrapper":"TRvjTkH3xRdU","image":"_1r6vQEjxldSx","text":"TG2yPP5J_Spt"};